import { apiBffMobileV2Carts } from './api'

export const deleteCart = async (cartId: string) => await apiBffMobileV2Carts.delete(`/${cartId}`)
